import React,{Component} from "react";
import { tarbookService } from "../../services/tarbook.service";
import Loader from "../../_helpers/Loader";
import { historypush } from "../../_helpers/utilities";
import AddEditShipBoardDetails from "./Component/addEditShipBoardDetails";
import DeleteshipDetails from "./Component/DeleteshipDetails";

class tarbookinformation extends Component{
    constructor(props){
        super(props);
        this.state={
            isLoading:false,
            userId:'',
            grade:'',
            tarRegisterationNumber:'',
            userName :'',
            dob:'',
            nationality:'',
            receiptNumber:'',
            serialNumber:'',
            receiptDate:'',
            passportNumber:'',
            passportDateofInitiation:'',
            cdcNumber:'',
            cdcDateOfInitiation:'',
            cdcPlaceofIssue:'',
            address:'',
            country:'',
            telNumber:'',
            mobileNumber:'',
            email:'',
            contactAddress:'',
            contactNumber:'',
            instituteName:'',
            instituteAddress:'',
            courseName:'',
            joiningDate:'',
            completionDate:'',
            tarBookNo:'',
            collection:'',
            payment:'',
            shipDetailsList:[],
            showAddEditModel:false,
            shipBoardId:"",
            showDeleteModel:false,
            selectIdToDelete:0,
        }
    }

    componentDidMount=()=>{
        document.getElementById("defaultOpen").click();
        const userID = localStorage.getItem("UserID");

        if(userID === ""){
            historypush('/login');
        }
        const Role = localStorage.getItem("RoleId");
        if(Role != 2){
            document.getElementById("show-tarbook").style.display = 'none';
        }
        if(Role == 2){
            console.log("Role 2");
            this.GetTarbookInformation();
            this.GetShipBoardDetails();
            
            
        }else{
            historypush('/login');
        }
    }

    /* <summary>
    date: 20-06-2022
    Name: VD
    description: This is used to get all the data of this page
    <summary>*/ 
    GetTarbookInformation=async()=>{
        try{
            this.setState({
                isLoading:true,
            })

            console.log("GetTarbookInformation");

            const userID = localStorage.getItem("UserID");
            const grade = localStorage.getItem("Grade");
            var response=await tarbookService.GetTarbookInformation(userID,grade);
            if(response.status===200){
                if(response.data !== ""){
                    this.setState({
                        tarRegisterationNumber:response.data.tarRegisterationNumber,
                        userName :response.data.userName,
                        dob:response.data.dob,
                        nationality:response.data.nationality,
                        receiptNumber:response.data.receiptNumber,
                        serialNumber:response.data.serialNumber,
                        receiptDate:response.data.receiptDate,
                        passportNumber:response.data.passportNumber,
                        passportDateofInitiation:response.data.passportDateofInitiation,
                        cdcNumber:response.data.cdcNumber,
                        cdcDateOfInitiation:response.data.cdcDateOfInitiation,
                        cdcPlaceofIssue:response.data.cdcPlaceofIssue,
                        address:response.data.address,
                        country:response.data.country,
                        telNumber:response.data.telNumber,
                        mobileNumber:response.data.mobileNumber,
                        email:response.data.email,
                        contactAddress:response.data.contactAddress,
                        contactNumber:response.data.contactNumber,
                        instituteName:response.data.instituteName,
                        instituteAddress:response.data.instituteAddress,
                        courseName:response.data.courseName,
                        joiningDate:response.data.joiningDate,
                        completionDate:response.data.completionDate,
                        tarBookNo:response.data.tarBookNo,
                        collection:response.data.collection,
                        payment:response.data.payment,
                    })
                }
            }
            else if(response.status===401){
                localStorage.clear();
                historypush('/login');
            }

            this.setState({
                isLoading:false,
            })
            console.log("GetTarbookInformation1");
        }
        catch(ex){}
    }

    /* <summary>
    date: 14-07-2022
    Name: VD
    description: This is used to get the list of all shipBoard Details
    <summary>*/ 
    GetShipBoardDetails=async()=>{
        try{
            this.setState({isLoading:true});
            console.log("GetShipBoardDetails");
            const userID = localStorage.getItem("UserID");
            var response = await tarbookService.GetShipBoardDetails(userID);
            if(response.status === 200){
                this.setState({
                    shipDetailsList:response.data,
                })
            }
            console.log("response",response);
            this.setState({isLoading:false});
            console.log("GetShipBoardDetails1");
        }catch(ex){
            return "";
        }
    }

    openContent=(evt, contentName)=> {
        //evt.pre
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(contentName).style.display = "block";
        evt.currentTarget.className += " active";
        
    }

    showModel=(id)=>{
        this.setState({
            showAddEditModel:true,
            shipBoardId:id,
        })
    }

    closeModel=()=>{
        this.setState({
            showAddEditModel:false,
            showDeleteModel:false,
        })
    }

    DeleteModel=(row)=>{
            this.setState({
                showDeleteModel:true,
                selectIdToDelete:row.shipBoardId,
            })
    }

    render(){
        const{
            isLoading,
            tarRegisterationNumber,
            userName ,
            dob,
            nationality,
            receiptNumber,
            serialNumber,
            receiptDate,
            passportNumber,
            passportDateofInitiation,
            
            cdcNumber,
            cdcDateOfInitiation,
            cdcPlaceofIssue,
            address,
            country,
            telNumber,
            mobileNumber,
            email,
            contactAddress,
            contactNumber,
            instituteName,
            instituteAddress,
            courseName,
            joiningDate,
            completionDate,
            tarBookNo,
            collection,
            payment,

            shipDetailsList,
            showAddEditModel,
            shipBoardId,
            
            showDeleteModel,
            selectIdToDelete,
        }=this.state;
        return(
            <div className="member-body" id="show-tarbook">
            {isLoading && <Loader />}
            <div className="about">
                <div className="container">
                <div>
                    <h3 className="heading">
                    TAR Book Information
                    </h3>
                </div>
                <div className="tab">
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Personal-information')} id="defaultOpen">Personal Information</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Passport-Details')} >Passport Details</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'CDC-Details')}>CDC Details</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Contact-Details')}>Contact Details</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Course-Details')}>Initial Training Course details</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Payment')}>Payment and collection type of TAR Book</button>
                    <button className="tablinks" onClick={(event)=> this.openContent(event, 'Ship-Details')}>Ship Board Details</button>	
                </div>
                <div id="Personal-information" className="tabcontent">
                    <div className="Personal-data">
                    <h3>Personal Information</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Onboard TAR Registration No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{tarRegisterationNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">Name of the Candidate :</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{userName}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="DOB" className="col-sm-4 col-form-label">Date of Birth :</span>
                        <div className="col-sm-8">
                            <label htmlFor="DOB" className="col-form-label">{dob}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nationality" className="col-sm-4 col-form-label">Nationality :</span>
                        <div className="col-sm-8">
                            <label htmlFor="nationality" className="col-form-label">{nationality}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="receiptnumber" className="col-sm-4 col-form-label">Receipt No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="receiptnumber" className="col-form-label" >{receiptNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="serialno" className="col-sm-4 col-form-label">Serial No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="serialno" className="col-form-label" >{serialNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="receiptdate" className="col-sm-4 col-form-label">Receipt Date :</span>
                        <div className="col-sm-8">
                            <label htmlFor="receiptdate" className="col-form-label" >{receiptDate}</label>
                        </div>
                        </div>
                    </form>
                    </div>
                </div>
                <div id="Passport-Details" className="tabcontent">
                <div className="Personal-data">
                    <h3>Passport Details</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Passport No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{passportNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">Date of Issue :</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{passportDateofInitiation}</label>
                        </div>
                        </div>
                        
                    </form>
                    </div>
                </div>
                <div id="CDC-Details" className="tabcontent">
                <div className="Personal-data">
                    <h3>CDC Details</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">CDC No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{cdcNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">Date of Issue :	</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{cdcDateOfInitiation}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="DOB" className="col-sm-4 col-form-label">Place of Issue :	</span>
                        <div className="col-sm-8">
                            <label htmlFor="DOB" className="col-form-label">{cdcPlaceofIssue}</label>
                        </div>
                        </div>
                        
                    </form>
                    </div>
                </div>
                <div id="Contact-Details" className="tabcontent">
                <div className="Personal-data">
                    <h3>Contact Details</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Address :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{address}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Country :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{country}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Whatsapp No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{telNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">Mobile No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{mobileNumber}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="DOB" className="col-sm-4 col-form-label">Email :</span>
                        <div className="col-sm-8">
                            <label htmlFor="DOB" className="col-form-label">{email}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nationality" className="col-sm-4 col-form-label">Contact Address :</span>
                        <div className="col-sm-8">
                            <label htmlFor="nationality" className="col-form-label">{contactAddress}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="receiptnumber" className="col-sm-4 col-form-label">Contact No :</span>
                        <div className="col-sm-8">
                            <label htmlFor="receiptnumber" className="col-form-label" >{contactNumber}</label>
                        </div>
                        </div>
                        
                    </form>
                    </div>
                </div>
                <div id="Course-Details" className="tabcontent">
                <div className="Personal-data">
                    <h3>Initial Training Course details</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">Presea Training Institute Name :	</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{instituteName}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">Presea Training Institute Address :	</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{instituteAddress}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="DOB" className="col-sm-4 col-form-label">Training Course :</span>
                        <div className="col-sm-8">
                            <label htmlFor="DOB" className="col-form-label">{courseName}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nationality" className="col-sm-4 col-form-label">Joining Date :</span>
                        <div className="col-sm-8">
                            <label htmlFor="nationality" className="col-form-label">{joiningDate}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="receiptnumber" className="col-sm-4 col-form-label">Course Completion Date :</span>
                        <div className="col-sm-8">
                            <label htmlFor="receiptnumber" className="col-form-label" >{completionDate}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="receiptnumber" className="col-sm-4 col-form-label">Pre Sea TAR Book No. :</span>
                        <div className="col-sm-8">
                            <label htmlFor="receiptnumber" className="col-form-label" >{tarBookNo}</label>
                        </div>
                        </div>
                    </form>
                    </div>
                </div>
                <div id="Payment" className="tabcontent">
                <div className="Personal-data">
                    <h3>Payment and collection type of TAR Book</h3>
                    <form className="read-msg-form mt-2">
                        <div className="form-group row">
                        <span htmlFor="Tar-registration" className="col-sm-4 col-form-label">For Collection :</span>
                        <div className="col-sm-8">
                            <label htmlFor="tar-registration" className="col-form-label">{collection}</label>
                        </div>
                        </div>
                        <div className="form-group row">
                        <span htmlFor="Nameofcanditate" className="col-sm-4 col-form-label">For Payment :</span>
                        <div className="col-sm-8">
                            <label htmlFor="Nameofcanditate" className="col-form-label">{payment}</label>
                        </div>
                        </div>
                        
                    </form>
                    </div>
                </div>
                <div id="Ship-Details" className="tabcontent">
                    <div className="Ship-detail">
                    <div className="table-responsive">
                        <table className="table ship-table">
                        <thead className="ship-table-head">
                            <tr>
                            <th className="sr-no">Sr No.</th>
                            <th>Ship Name</th>
                            <th>IMO No.</th>
                            <th>Type</th>
                            <th>DWT</th>
                            <th>
                                <table>
                            <th className="shipDetailtable" style={{width:'90px'}}></th>
                            <th className="shipDetailmake">Make</th>
                            <th className="shipDetailtype">Type</th>
                            <th className="shipDetailpower">Power</th>
                            </table>
                            </th> 
                            <th>Joining Date</th>
                            <th>Leaving Date</th>
                            <th>Days</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody className="ship-table-body">
                        {shipDetailsList.map((item)=>
                            <tr className="white-color">
									<td className="sr-no">{item.srNo}</td>
									<td>{item.shipName}</td>
									<td>{item.imoNo}</td>
									<td>{item.type}</td>
									<td>{item.dwt}</td>
									<td>
										<table>
											<tr style={{border:'none'}}>
												<td className="engine-type-data" style={{width:'90px'}}>Main Engine:</td>
                                                <td className="tarbook-table">{item.mainEngineMake }</td>
												<td className="tarbook-table">{item.mainEngineType}</td>
                                                <td className="tarbook-table">{item.mainEnginePower}</td>
											</tr>
											<tr style={{border:'none'}}>
												<td className="engine-type-data">Aux. Engine:</td>
                                                <td className="tarbook-table">{item.auxEngineMake}</td>
                                                <td className="tarbook-table">{item.auxEngineType}</td>
                                                <td className="tarbook-table">{item.auxEnginePower}</td>
											</tr>
											<tr style={{border:'none'}}>
												<td className="engine-type-data">Aux. Boiler:</td>
												<td className="tarbook-table">{item.auxBoilerMake}</td>
												<td className="tarbook-table">{item.auxBoilerType}</td>
												<td className="tarbook-table">{item.auxBoilerPower}</td>
											</tr>
										</table>
									</td>
									{/* <td>
										<table style={{width:'140px'}}>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.mainEngineMake}</td>
												<td>{item.mainEngineType}</td>
                                                <td>{item.auxEnginePower}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxEngineMake}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxBoilerMake}</td>
											</tr>
										</table>
									</td>
									<td>
										<table style={{width:'135px'}}>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.mainEngineType}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxEngineType}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxBoilerType}</td>
											</tr>
										</table>
									</td>
                                    <td>
										<table style={{width:'145px'}}>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.mainEnginePower}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxEnginePower}</td>
											</tr>
											<tr style={{border:'none',height:'120px'}}>
												<td>{item.auxBoilerPower}</td>
											</tr>
										</table>
									</td> */}
									<td>{item.joiningDate}</td>
									<td>{item.leavingDate}</td>
									<td>{item.days}</td>
									<td className="tarbook-edit"><i onClick={()=>this.showModel(item.shipBoardId)} style={{cursor:'pointer'}} className="fa fa-pencil-square-o"></i></td>
                                    <td className="delete"><i className="fa fa-trash" onClick={()=>this.DeleteModel(item)} style={{cursor:'pointer',fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>
                            </tr>
                        )}
                        </tbody>
                        </table>
                    </div>
                    <button type="button" onClick={()=>this.showModel(0)} className="btn btn-white" data-bs-toggle="modal" data-bs-target="#myModal">Add Data<i className="fa fa-plus" /></button>
                    </div>
                </div>
                {/* <button type="button" className="question-button btn btn-white">Back</button> */}
                </div>
            </div>
            {showAddEditModel && 
                <AddEditShipBoardDetails 
                    shipBoardId={shipBoardId}
                    closeModel={this.closeModel}
                    GetShipBoardDetails={this.GetShipBoardDetails}
                />
            }

            {showDeleteModel &&
                <DeleteshipDetails
                closeModel={this.closeModel} 
                selectIdToDelete={selectIdToDelete}
                GetShipBoardDetails={this.GetShipBoardDetails}
                />
            }
            </div>
        )
    }
}

export default tarbookinformation;